module.exports = __webpack_public_path__ + "static/media/whatsApp.f5f0fb9f.svg";